@if (step) {
  <div
    class="guided-tour">
    <div class="guided-tour__overlay">
      @if (showSkeleton) {
        <e-guided-tour-skeleton
          (exitDemoClick)="onExitDemoClick()"
          @fadeOut
          [step]="step"></e-guided-tour-skeleton>
      } @if (!showSkeleton) {
      <e-portal
        [stepPortal]="step.portal"
        class="guided-tour__portal"
      ></e-portal>
      @if (step.portal.exposedElement) {
        <e-exposed-element
          (exposedElementClick)="onExposedElementClick()"
          [stepExposedElement]="step.portal.exposedElement"
        ></e-exposed-element>
      }
      <e-guided-tour-dialog
        (exitDemoClick)="onExitDemoClick()"
        (nextStepClick)="onNextStepClick()"
        [ngClass]="{'portal__overlay--fixed': step && step.dialog.position === 'fixed'}"
        [step]="step"
        class="guided-tour__step"
      ></e-guided-tour-dialog>
    }
    </div>
  </div>
}

